import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import isMobileViewHook from '../../../hooks/isMobileView';
import DownloadButton from '../../UI/DownloadButton/DownloadButton';
import classes from './FileCard.module.css';
import {
  downloadSrc,
  parseTextWithNewLineToElement,
  parseLocationToPath,
} from '../../../utils';
import googleAnalytics from '../../../utils/googleAnalytics';

const FileCard = ({ content, color, height, onBackToTop }) => {
  const titleHeight = `${height * 1.3}rem`;
  const [loadingDownload, setLoadingDownload] = useState();
  const { thumbnail, title, description, media } = content;
  const isMobileView = isMobileViewHook();
  const hub = useSelector((state) => state.hub.hub);

  const location = useLocation();
  const currentPath = parseLocationToPath(location);
  useEffect(() => {
    if (currentPath.search('home') === -1) {
      onBackToTop();
    }
  }, [currentPath, onBackToTop]);

  const downloadTextFile = () => {
    const element = document.createElement('a');
    element.setAttribute(
      'href',
      `data:text/plain;charset=utf-8,${encodeURIComponent(content.description)}`
    );
    element.setAttribute('download', content.title);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  const downloadHandler = async () => {
    setLoadingDownload(true);
    try {
      await downloadSrc(media.url, title);
      downloadTextFile();
      setLoadingDownload(false);
      googleAnalytics({
        event: 'file_download',
        file_url: content.media.url,
        file_name: title,
        section_title: hub.name,
      });
    } catch (error) {
      setLoadingDownload(false);
    }
  };

  return (
    <div className={classes.card}>
      {isMobileView ? (
        <h1 className={classes.title}>{title}</h1>
      ) : (
        <h1
          style={{ display: 'flex', alignItems: 'center', height: titleHeight }}
          className={classes.title}
        >
          {title}
        </h1>
      )}

      <hr className={classes.line} style={{ borderColor: color }} />
      {isMobileView ? (
        <div className={classes.content}>
          <img
            data-testid="file-thumbnail"
            src={thumbnail ? thumbnail[0].url : media.url}
            alt={title}
            className={classes.image}
          />
          {description && (
            <div className={classes.description}>
              {parseTextWithNewLineToElement(description)}
            </div>
          )}

          <DownloadButton
            color={color}
            downloadable
            loadingDownload={loadingDownload}
            onDownload={downloadHandler}
          />
        </div>
      ) : (
        <div className={classes.contentL}>
          <div className={classes.dowmloadZone}>
            <img
              data-testid="file-thumbnail"
              src={thumbnail ? thumbnail[0].url : media.url}
              alt={title}
              className={classes.imageL}
            />
            <DownloadButton
              color={color}
              downloadable
              loadingDownload={loadingDownload}
              onDownload={downloadHandler}
            />
          </div>
          {description && (
            <div className={classes.description}>
              {parseTextWithNewLineToElement(description)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

FileCard.propTypes = {
  content: PropTypes.shape({
    viewType: PropTypes.oneOf(['FILE', 'GENERAL']),
    thumbnail: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
      })
    ),
    media: PropTypes.shape({ url: PropTypes.string }),
    description: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.number,
    size: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  color: PropTypes.string.isRequired,
  onBackToTop: PropTypes.func,
  height: PropTypes.number.isRequired,
};

FileCard.defaultProps = {
  onBackToTop: () => {},
};

export default FileCard;
